module.exports = __webpack_public_path__ + "static/media/28-min.207c8423.jpg";